import { createContext } from "react"
import type { DateTime } from "luxon"

interface Range {
  fromDate: DateTime | null
  toDate: DateTime | null
}

/** The range being edited, which every day of the calendar paints itself against. */
export const RangeContext = createContext<Range>({ fromDate: null, toDate: null })

/** The ring around the end being edited, which the calendar leaves room for. */
export const DAY_RING_WIDTH = 3

export type Band = "full" | "right" | "left" | null

/**
 * Where a day sits in the range: whether it is one of the ends, and how much of the band
 * behind it is painted. The ends get half, towards the other end.
 */
export const getRangeMark = (
  day: DateTime,
  { fromDate, toDate }: Range,
): { isEnd: boolean; band: Band } => {
  const isFrom = !!fromDate && day.hasSame(fromDate, "day")
  const isTo = !!toDate && day.hasSame(toDate, "day")
  const isEnd = isFrom || isTo
  if (!fromDate || !toDate || toDate.startOf("day") <= fromDate.startOf("day")) {
    return { isEnd, band: null }
  }
  if (isFrom) return { isEnd, band: "right" }
  if (isTo) return { isEnd, band: "left" }
  const isBetween = day > fromDate.endOf("day") && day < toDate.startOf("day")
  return { isEnd, band: isBetween ? "full" : null }
}
